var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { useMemo } from "react";
import { usePatientId } from "@madmedical/user";
import { useGetPatientLogisticsDevicesQuery } from "@madmedical/callcenter";
import { useGetDevicesQuery } from "./api";
const resolveDevice = (device, logisticsDevice) => {
    const { provider, forHumans, connectedAt: connectedAtString, lastRecordedAt: lastRecordedAtString } = device, rest = __rest(device, ["provider", "forHumans", "connectedAt", "lastRecordedAt"]);
    const connectedAt = connectedAtString ? new Date(connectedAtString) : null;
    const lastRecordedAt = lastRecordedAtString
        ? new Date(lastRecordedAtString)
        : null;
    return Object.assign({ provider, deviceName: forHumans, connectedAt,
        lastRecordedAt, serialNumber: logisticsDevice === null || logisticsDevice === void 0 ? void 0 : logisticsDevice.serialNumber, ownership: logisticsDevice === null || logisticsDevice === void 0 ? void 0 : logisticsDevice.ownership }, rest);
};
const useDevices = () => {
    const { patientId } = usePatientId();
    const { data: apiDevices, isLoading: isApiLoading, isFetching, refetch, } = useGetDevicesQuery(patientId);
    const { data: logisticsDevices, isLoading: isLogisticsApiLoading, isFetching: isLogisticsFetching, } = useGetPatientLogisticsDevicesQuery(patientId);
    const resolvedDevices = useMemo(() => {
        var _a;
        return (_a = apiDevices === null || apiDevices === void 0 ? void 0 : apiDevices.map((device) => resolveDevice(device, device.type === "ble"
            ? logisticsDevices === null || logisticsDevices === void 0 ? void 0 : logisticsDevices.find((logisticsDevice) => logisticsDevice.deviceType.provider ===
                device.provider)
            : undefined))) !== null && _a !== void 0 ? _a : [];
    }, [apiDevices, logisticsDevices]);
    return {
        isLoading: isApiLoading || isLogisticsApiLoading,
        isFetching: isFetching || isLogisticsFetching,
        refetch,
        devices: resolvedDevices,
        connectedDeviceCount: resolvedDevices.filter(({ isConnected }) => isConnected).length,
    };
};
export default useDevices;
